const getBetsWithEvents = (betInfo, winInfo) => {
  const winEvents = winInfo?.AdditionalInfo.WinInfos;

  return betInfo.AdditionalInfo.BetInfos.map((bet) => {
    const wonBet = winEvents?.find((item) => item.RoundId === bet.RoundId);
    return { ...bet, winInfo: wonBet };
  });
};

const mapSelection = (selection) => ({
  id: selection.RoundId,
  roundId: selection.RoundId,
  name: selection.GameName,
  price: selection.Odds,
  amount: selection.BetAmount,
  possibleWin: selection.PossibleWin,
  numbers: selection.Numbers?.length ? selection.Numbers : null,
  rawNumbers: selection.Numbers?.length ? selection.Numbers.join(',') : null,
  marketName: selection.MarketName,
});

export const mapPascalSelections = (ticket) => {
  const { casinoInfo } = ticket;

  const originalSelections = casinoInfo.BetMultiplyInfo.flatMap((betInfo, betIndex) => {
    const betId = betInfo.TransactionId?.split('stage')[0]; // TODO remove someday

    const winInfo = betId
      ? casinoInfo.WinMultiplyInfo?.find((winDetails) => {
        const winId = winDetails.TransactionId?.split('stage')[0];
        return betId === winId;
      })
      : casinoInfo.WinMultiplyInfo?.[betIndex];

    return getBetsWithEvents(betInfo, winInfo);
  });

  return originalSelections.map(mapSelection);
};
